import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CameraAiIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.43285 2.83573L3.66272 1.68641C3.74254 1.28729 4.09298 1 4.5 1C4.90702 1 5.25746 1.28729 5.33728 1.68641L5.56715 2.83573C5.60003 3.00016 5.61647 3.08237 5.65389 3.15012C5.69945 3.23262 5.76738 3.30055 5.84987 3.34611C5.91763 3.38353 5.99984 3.39997 6.16427 3.43285L7.31359 3.66272C7.71271 3.74254 8 4.09298 8 4.5C8 4.90702 7.71271 5.25746 7.31359 5.33728L6.16427 5.56715C5.99984 5.60003 5.91763 5.61647 5.84987 5.65389C5.76738 5.69945 5.69945 5.76738 5.65389 5.84987C5.61647 5.91763 5.60003 5.99984 5.56715 6.16427L5.33728 7.31359C5.25746 7.71271 4.90702 8 4.5 8C4.09298 8 3.74254 7.71271 3.66272 7.31359L3.43285 6.16427C3.39997 5.99984 3.38353 5.91763 3.34611 5.84987C3.30055 5.76738 3.23262 5.69945 3.15012 5.65389C3.08237 5.61647 3.00016 5.60003 2.83573 5.56715L1.68641 5.33728C1.28729 5.25746 1 4.90702 1 4.5C1 4.09298 1.28729 3.74254 1.68641 3.66272L2.83573 3.43285C3.00016 3.39997 3.08237 3.38353 3.15013 3.34611C3.23262 3.30055 3.30055 3.23262 3.34611 3.15013C3.38353 3.08237 3.39997 3.00016 3.43285 2.83573Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.99587 2.75C7.99587 2.33579 8.33166 2 8.74587 2H9.60714C10.2401 2 10.7927 2.37247 11.0661 2.92054L11.5143 3.81894C11.5512 3.89297 11.6045 3.90909 11.631 3.90909H12.9107C14.111 3.90909 15 4.93391 15 6.09091V11.8182C15 12.9752 14.111 14 12.9107 14H3.08929C1.889 14 1 12.9752 1 11.8182V8.74722C1 8.333 1.33579 7.99722 1.75 7.99722C2.16421 7.99722 2.5 8.333 2.5 8.74722V11.8182C2.5 12.2427 2.81024 12.5 3.08929 12.5H12.9107C13.1898 12.5 13.5 12.2427 13.5 11.8182V6.09091C13.5 5.66637 13.1898 5.40909 12.9107 5.40909H11.631C10.998 5.40909 10.4454 5.03662 10.172 4.48854L9.72383 3.59015C9.6869 3.51612 9.63363 3.5 9.60714 3.5H8.74587C8.33166 3.5 7.99587 3.16421 7.99587 2.75Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.51539 8.05446C6.5 8.15162 6.5 8.26775 6.5 8.5C6.5 8.73225 6.5 8.84838 6.51539 8.94554C6.6001 9.48041 7.01959 9.8999 7.55446 9.98461C7.65162 10 7.76775 10 8 10C8.23225 10 8.34838 10 8.44554 9.98461C8.98041 9.8999 9.3999 9.48041 9.48461 8.94554C9.5 8.84838 9.5 8.73225 9.5 8.5C9.5 8.26775 9.5 8.15162 9.48461 8.05446C9.3999 7.51959 8.98041 7.1001 8.44554 7.01539C8.34838 7 8.23225 7 8 7C7.76775 7 7.65162 7 7.55446 7.01539C7.01959 7.1001 6.6001 7.51959 6.51539 8.05446Z"
		></path>
	</svg>
))
